<template>
  <div style="position: relative;">
    <el-form ref="serviceAchievementFilter" :model="serviceAchievementList" :size="defaultFormItemSize"
             label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="成果名称" prop="formFilter.achievementName">
          <el-input class="filter-item" v-model="serviceAchievementList.formFilter.achievementName"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="参展单位" prop="formFilter.exhibitionUnit">
          <el-input class="filter-item" v-model="serviceAchievementList.formFilter.exhibitionUnit"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetServiceAchievement">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshServiceAchievement(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('serviceAchievement:all')"
                   @click="onServiceAchievementAddClick()">
          新增
        </el-button>
        <el-button slot="operator" type="success" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('serviceAchievement:all')"
                   @click="onImportClick()">
          导入
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="serviceAchievement" :data="serviceAchievementList.ServiceAchievement.impl.dataList" :size="defaultFormItemSize" @sort-change="serviceAchievementList.ServiceAchievement.impl.onSortChange"
                  header-cell-class-name="table-header-gray"
                  highlight-current-row @current-change="serviceAchievementList.ServiceAchievement.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="serviceAchievementList.ServiceAchievement.impl.getTableIndex" />
          <el-table-column label="技术成果展品名称" prop="achievementName" sortable="custom">
          </el-table-column>
          <el-table-column label="展品展示简介" prop="achievementDesc" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="参展单位" prop="exhibitionUnit" sortable="custom">
          </el-table-column>
          <el-table-column label="科技特派员" prop="specialistName" sortable="custom">
          </el-table-column>
          <el-table-column label="图片地址" prop="imageUrl" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-image v-for="item in parseUploadData(scope.row.imageUrl, {id: scope.row.id, fieldName: 'imageUrl', asImage: true})"
                        :preview-src-list="getPictureList(scope.row.imageUrl, {id: scope.row.id, fieldName: 'imageUrl', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="remark" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime" sortable="custom" width="180px">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="150px">
            <template slot-scope="scope">
              <el-button @click.stop="onServiceAchievementEditClick(scope.row)" type="text" :size="defaultFormItemSize"
                         :disabled="!checkPermCodeExist('serviceAchievement:all')">
                编辑
              </el-button>
              <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                         :disabled="!checkPermCodeExist('serviceAchievement:all')">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="serviceAchievementList.ServiceAchievement.impl.totalCount"
            :current-page="serviceAchievementList.ServiceAchievement.impl.currentPage"
            :page-size="serviceAchievementList.ServiceAchievement.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="serviceAchievementList.ServiceAchievement.impl.onCurrentPageChange"
            @size-change="serviceAchievementList.ServiceAchievement.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>

    <el-dialog title="导入服务成果信息" :visible.sync="serviceAchievementList.importDialogVisible" width="500px" :close-on-click-modal="false"
               :close-on-press-escape="false"
    >
      <el-upload
        ref="upload"
        :auto-upload="false"
        :on-change="onFileChange"
        :file-list="serviceAchievementList.fileList"
        accept=".xlsx,.xls"
        drag
        :limit="1"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">仅支持xlsx/xls格式文件，且不超过10MB</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button :size="defaultFormItemSize" @click="serviceAchievementList.importDialogVisible = false">取消</el-button>
        <el-button type="primary" :size="defaultFormItemSize" :loading="serviceAchievementList.isImporting" @click="onImportSubmitClick">确定导入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapGetters } from 'vuex';
import { findItemFromList } from '@/utils';
// eslint-disable-next-line no-unused-vars
import rules from '@/utils/validate.js';
import { TableWidget } from '@/utils/widget.js';
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
import { ServiceAchievementController } from '@/api';

export default {
  name: 'serviceAchievementList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      fit: 'scale-down',
      serviceAchievementList: {
        formFilter: {
          achievementName: undefined,
          exhibitionUnit: undefined
        },
        formFilterCopy: {
          achievementName: undefined,
          exhibitionUnit: undefined
        },
        ServiceAchievement: {
          impl: new TableWidget(this.loadServiceAchievementWidgetData, this.loadServiceAchievementVerify, true, true)
        },
        importDialogVisible: false,
        isImporting: false,
        fileList: [],
        isInit: false
      }
    }
  },
  methods: {
    onResetServiceAchievement () {
      this.$refs.serviceAchievementFilter.resetFields();
      this.refreshServiceAchievement(true);
    },
    loadServiceAchievementWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        serviceAchievementDtoFilter: {
          achievementName: this.serviceAchievementList.formFilterCopy.achievementName,
          exhibitionUnit: this.serviceAchievementList.formFilterCopy.exhibitionUnit
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        ServiceAchievementController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          if (this.serviceAchievementList.ServiceAchievement.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.serviceAchievementList.ServiceAchievement.impl.currentRow.id, 'id');
              this.$refs.serviceAchievement.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadServiceAchievementVerify (data) {
      return true;
    },
    refreshServiceAchievement (resetPage) {
      this.serviceAchievementList.formFilterCopy = JSON.parse(JSON.stringify(this.serviceAchievementList.formFilter));
      if (resetPage) {
        this.serviceAchievementList.ServiceAchievement.impl.refreshTable(true, 1);
      } else {
        this.serviceAchievementList.ServiceAchievement.impl.refreshTable();
      }
      if (!this.serviceAchievementList.isInit) {
        // 初始化下拉数据
      }
      this.serviceAchievementList.isInit = true;
    },
    onServiceAchievementAddClick () {
      let params = {
        mode: 'add',
        closeVisible: 1
      };
      this.$router.push({name: 'serviceAchievementForm', query: params});
    },
    onServiceAchievementEditClick (row) {
      let params = {
        id: row.id
      };
      params.closeVisible = 1;
      this.$router.push({name: 'serviceAchievementForm', query: params});
    },
    onDeleteClick (row) {
      this.$confirm('确定要删除该服务成果信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ServiceAchievementController.delete(this, { id: row.id }).then(res => {
          this.$message.success('删除成功');
          this.refreshServiceAchievement(false);
        }).catch(e => {
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },
    onImportClick () {
      this.serviceAchievementList.fileList = [];
      this.serviceAchievementList.importDialogVisible = true;
    },
    onFileChange (file, fileList) {
      this.serviceAchievementList.fileList = fileList.slice(-1);
    },
    onImportSubmitClick () {
      if (this.serviceAchievementList.fileList.length === 0) {
        this.$message.warning('请选择要导入的文件');
        return;
      }
      this.serviceAchievementList.isImporting = true;
      let formData = new FormData();
      formData.append('file', this.serviceAchievementList.fileList[0].raw);
      ServiceAchievementController.importData(this, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if (res.success) {
          let data = res.data;
          this.$message.success(`导入完成：成功${data.successCount}条，失败${data.failCount}条`);
          if (data.failMessages && data.failMessages.length > 0) {
            this.$alert(data.failMessages.join('<br/>'), '导入失败详情', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定'
            });
          }
          this.serviceAchievementList.importDialogVisible = false;
          this.refreshServiceAchievement(true);
        } else {
          this.$message.error(res.message);
        }
      }).catch(e => {
        this.$message.error('导入失败');
      }).finally(() => {
        this.serviceAchievementList.isImporting = false;
      });
    },
    onResume () {
      this.refreshServiceAchievement();
    },
    formInit () {
      this.refreshServiceAchievement();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>

<style scoped>
</style>
